exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fiveStar--anAd8{display:flex;align-items:center;font-size:12px;color:rgba(0,0,0,.6);margin-bottom:4px}.padiLogo--3Vfie{width:16px;height:16px;margin-right:4px}", ""]);

// Exports
exports.locals = {
	"fiveStar": "fiveStar--anAd8",
	"padiLogo": "padiLogo--3Vfie"
};